
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/image-watermark-remover",
      function () {
        return require("private-next-pages/image-watermark-remover/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/image-watermark-remover"])
      });
    }
  